import type { EntityConfig } from '../types'

export const mmDepositEntity: EntityConfig = {
  name: 'mm-deposit',
  label: 'Deposit',
  pluralLabel: 'Deposits',
  status: {
    field: 'status',
    options: [
      { value: 'completed', label: 'Completed', variant: 'success' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'in-transit', label: 'In Transit', variant: 'default' },
      { value: 'failed', label: 'Failed', variant: 'destructive' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'completed', label: 'Completed' },
      { value: 'pending', label: 'Pending' },
      { value: 'in-transit', label: 'In Transit' },
      { value: 'failed', label: 'Failed' },
    ],
    mappings: {
      all: ['completed', 'pending', 'in-transit', 'failed'],
      completed: ['completed'],
      pending: ['pending'],
      'in-transit': ['in-transit'],
      failed: ['failed'],
    }
  },
  queryFields: {
    merchantName: { field: 'merchantName', type: 'text' },
    reason: { field: 'reason', type: 'text' },
    reference: { field: 'reference', type: 'text' },
  },
  uiFilterFields: ['status', 'method'],
}
